import { globalStyleVariables } from "../../styles/variables"
import styled from "styled-components"

export const Wrapper = styled.footer`
  color: #7c848e;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    padding: ${globalStyleVariables.mobile.SLAB_TOP_BOTTOM_PADDING} 0;
  }

  .divider-wrapper {
    margin: 48px 0px;
    width: 100%;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin: 24px 0px;
    }
  }

  #logo-badges-grid {
    align-items: center;
    margin-top: 48px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      align-items: flex-start;
      margin-top: 24px;

      .column {
        margin-bottom: 10px;
      }
    }
  }

  .grid {
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      flex-flow: column;
    }
  }

  .column {
    display: flex;
    flex-direction: column;
    max-width: 250px;
    // padding: 0 10px;
    line-height: normal;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin-bottom: 40px;
      max-width: unset;
    }

    a {
      color: inherit;
      text-decoration: none;
      line-height: 1.38;
      font-family: "Inter", sans-serif;
    }

    h4 {
      text-transform: capitalize;
      font-weight: 700;
      white-space: nowrap;
      color: ${globalStyleVariables.WHITE_PLACEHOLDER};
      font-size: 18px;
    }

    ul {
      margin-top: 20px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        margin-top: unset;
      }

      li {
        list-style-type: none;
        margin: 15px 0;
        color: ${globalStyleVariables.WHITE_ACTIVE};
      }
    }

    p {
      color: ${globalStyleVariables.WHITE_ACTIVE};
    }
  }

  .copyright-section {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-family: "Inter", sans-serif;
    color: ${globalStyleVariables.IMAGEKIT_GRAY_500};

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      flex-flow: column;
      gap: 20px;
    }

    .links {
      color: white;
      display: flex;
      gap: 32px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center;
      }
    }

    .social-icons {
      display: flex;
      align-items: flex-end;
      gap: 20px;

      img {
        height: 24px;
      }
    }
  }
`
